import { useEffect } from "react";

const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const MicrosoftClarity = ({ consentGiven, marketingConsent = false }) => {
  useEffect(() => {
    if (!consentGiven || !CLARITY_ID) return undefined;
    if (!window.clarity) {
      window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    }
    window.clarity("consentv2", {
      analytics_Storage: "granted", ad_Storage: marketingConsent ? "granted" : "denied",
    });
    if (!document.getElementById("pp-clarity-sdk")) {
      const script = document.createElement("script");
      script.id = "pp-clarity-sdk";
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
      if (window.cspNonce) script.setAttribute("nonce", window.cspNonce);
      document.head.appendChild(script);
    } else {
      window.clarity("start");
    }
    return () => {
      window.clarity?.("consentv2", { analytics_Storage: "denied", ad_Storage: "denied" });
      window.clarity?.("stop");
    };
  }, [consentGiven, marketingConsent]);
  return null;
};
export default MicrosoftClarity;
